import {
  // eslint-disable-next-line no-restricted-imports
  Button as MuiButton,
  createStyles,
  makeStyles,
  Theme,
  // eslint-disable-next-line no-restricted-imports
  Typography,
} from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    button: {
      padding: '8px 24px',
      marginRight: '8px',
      borderRadius: 0,
      boxShadow: 'none',
    },
    groupedButton: {
      '&:not(:last-child)': {
        borderRight: 'solid 1px white!important',
      },
      marginRight: '0',
    },
    containedPrimary: {
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: '#FF964D',
        boxShadow: 'none',
      },
    },
    outlined: {
      backgroundColor: 'white',
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
      },
    },
  }),
);

export type ButtonProps = React.ComponentProps<typeof MuiButton>;

/**
 * @deprecated in favor of components from reactApp/ui which use theme overrides
 */

export const Button = React.forwardRef<HTMLButtonElement, React.PropsWithChildren<ButtonProps>>(
  ({ variant = 'contained', color = 'primary', className, children, ...otherProps }, ref) => {
    const classes = useStyles();

    return (
      <MuiButton
        ref={ref}
        {...otherProps}
        className={`${classes.button} ${
          variant === 'contained' && color === 'primary' && classes.containedPrimary
        } ${variant === 'outlined' && classes.outlined} ${className}`}
        variant={variant}
        color={color}
      >
        {children}
      </MuiButton>
    );
  },
);

export const GroupedButton = React.forwardRef<
  HTMLButtonElement,
  React.PropsWithChildren<ButtonProps>
>((props, ref) => {
  const classes = useStyles({});
  const className = `${classes.groupedButton} ${props.className}`;
  return <Button ref={ref} {...props} className={className} />;
});

export const CloseButton: React.FC<Omit<ButtonProps, 'variant'>> = (props) => (
  <Button variant='outlined' {...props}>
    <Typography variant='h5'>Close</Typography>
  </Button>
);

export const CancelButton: React.FC<Omit<ButtonProps, 'variant'>> = (props) => (
  <Button variant='outlined' {...props}>
    <Typography variant='h5'>Cancel</Typography>
  </Button>
);

export const ConfirmButton: React.FC<Omit<ButtonProps, 'variant'>> = ({
  onClick,
  children,
  disabled,
}) => (
  <Button onClick={onClick} disabled={disabled}>
    <Typography variant='h5'>{children}</Typography>
  </Button>
);

export const GoBackButton: React.FunctionComponent<{ goBack: () => void }> = ({ goBack }) => (
  <ConfirmButton onClick={goBack} children={'Go Back'} />
);
